export const PROFILE_CHAPTER_TITLES = Object.freeze({
  PERSON: 'Person',
  COMMUNICATION: 'Communication',
  WHAT_HELPS: 'What Helps',
  WATCH_FOR: 'Watch For',
  DAILY_LIFE: 'Daily Life',
  SAFETY: 'Safety',
  HEALTH_CARE: 'Health & Care',
  MEDICATIONS: 'Medications',
  ALLERGIES: 'Allergies',
  GOALS: 'Goals',
});

export const PROFILE_CHAPTER_ORDER = Object.freeze([
  PROFILE_CHAPTER_TITLES.PERSON,
  PROFILE_CHAPTER_TITLES.COMMUNICATION,
  PROFILE_CHAPTER_TITLES.WHAT_HELPS,
  PROFILE_CHAPTER_TITLES.WATCH_FOR,
  PROFILE_CHAPTER_TITLES.DAILY_LIFE,
  PROFILE_CHAPTER_TITLES.SAFETY,
  PROFILE_CHAPTER_TITLES.HEALTH_CARE,
  PROFILE_CHAPTER_TITLES.MEDICATIONS,
  PROFILE_CHAPTER_TITLES.ALLERGIES,
  PROFILE_CHAPTER_TITLES.GOALS,
]);
